export class ImageFormat {
  constructor(obj, imgBasePath) {
    this.name = obj.name;
    this.url = imgBasePath + obj.url;
  }
}

export class Image {
  constructor(obj, imgBasePath) {
    this.id = obj.id;
    this.name = obj.name;
    this.alternativeText = obj.alternativeText;
    this.caption = obj.caption;
    this.formats = {
      thumbnail: obj.formats?.thumbnail ? new ImageFormat(obj.formats.thumbnail, imgBasePath) : null,
      large: obj.formats?.large ? new ImageFormat(obj.formats.large, imgBasePath) : null,
      medium: obj.formats?.medium ? new ImageFormat(obj.formats.medium, imgBasePath) : null,
      small: obj.formats?.small ? new ImageFormat(obj.formats.small, imgBasePath) : null
    };
    this.url = imgBasePath + obj.url;
  }
}